<template>
  <el-form
    status-icon
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    ref="ruleForm"
    label-width="120px"
    v-loading="formLoading"
    class="carpo-form demo-ruleForm"
  >
    <VehicleSelect
      prop="vehicle_id"
      :model="ruleForm.vehicle_id"
      @update="ruleForm.vehicle_id = $event"
      :disabled="ruleForm.disabled"
    />
    <!-- <el-tooltip class="item" effect="dark" :content="$t('SEARCH_BY', {
        type:
          $t('VEHCILE_NAME') + ' ' + $t('AND') + ' ' + $t('LICENSE_PLATE'),
      })
        " placement="top">
        <el-form-item :label="$t('VEHICLE_TITLE')" prop="vehicle_id" class="information" v-loading="loading"
          element-loading-spinner="el-icon-loading">
          <el-select v-model="ruleForm.vehicle_id" filterable @change="formChanged" :placeholder="$t('SELECT_PLACEHOLDER')">
            <el-option v-for="item in cars" :key="item.id" :label="item.license_plate.substring(7, 9) +
              '|' +
              item.license_plate.substring(4, 7) +
              alphaList.find(
                (i) => i.code == item.license_plate.substring(2, 4)
              ).char +
              item.license_plate.substring(0, 2) +
              ' - ' +
              item.vehicle.fa_title
              " :value="item.id">
              <LicenseOption :license_plate="item.license_plate" :vehicle="item.vehicle" :chars="alphaList" />
            </el-option>
          </el-select>
        </el-form-item>
      </el-tooltip> -->
    <el-form-item :label="$t('DATE_')" prop="date">
      <date-picker
        color="#151515"
        class="el-input__inner"
        v-model="ruleForm.date"
        format="jYYYY-jMM-jDD"
        clearable
        @change="formChanged"
        :max="maxDate"
        :locale="$i18n.locale"
      />
    </el-form-item>

    <el-form-item class="flex justify-end col-span-full mt-4">
      <slot> </slot>
      <el-button type="success" @click="submitForm('ruleForm')">
        {{ $t('SEARCH') }}
      </el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import LicenseOption from '@/components/cars/LicenseOption.vue'
// import { routingHistory, routinAnomaly } from "@/api/reports";
import { tripsList } from '@/api/reports'
// import { carsListSummary } from '@/api/cars'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
// import { licenseChars } from '@/api/global'
import VehicleSelect from '@/components/elements/vehiclesSelect.vue'

export default {
  components: {
    LicenseOption,
    VehicleSelect,
  },
  mixins: [jalaliToGregorian, gregorianToJalali],
  data() {
    return {
      tableData: [],
      lastData: null,
      cars: [],
      alphaList: [
        {
          code: '',
          char: '',
          id: '',
        },
      ],
      loading: true,
      formLoading: false,
      selectedId: null,
      ruleForm: {
        date: '',
        end_datetime: '',
        vehicle_id: '',
        value1: [new Date(2021, 9, 10, 8, 40), new Date(2021, 9, 10, 9, 40)],
      },

      rules: {
        vehicle_id: {
          required: true,
          message: this.$i18n.t('REQUIRED_CHOOSE', {
            type: this.$i18n.t('VEHICLE_TITLE'),
          }),
          trigger: 'blur',
        },
        date: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('START_DATE'),
            }),
            trigger: 'blur',
          },
        ],
        end_datetime: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('END_DATE'),
            }),
            trigger: 'blur',
          },
        ],

        value1: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_CHOOSE', {
              type: this.$i18n.t('TIME'),
            }),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    formChanged() {
      this.$emit('tableData', {
        stops: [],
        trips: [],
      })
      this.$emit('vehicleId', '')
      this.$emit('anomaly', [])
      this.$emit('path', null)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formLoading = true

          const actionPayload = [
            this.ruleForm.vehicle_id,
            `${this.jalaliToGregorian(this.ruleForm.date, this.$i18n.locale)}`,
          ]
          tripsList.api(actionPayload).then((res) => {
            this.formLoading = false
            // console.log(res)
            if (res) {
              this.$emit('tableData', res)
              this.$emit('vehicleId', this.ruleForm.vehicle_id)
              //   if (this.lastData != null) {
              //     this.$emit('realtime', true)
              //   }
              //   this.lastData = res
              //   this.$emit('path', res)
            } else {
              this.$notify.error({
                title: this.$i18n.t('NO_DATA_FOR_VEHICLE'),
                duration: 5000,
                customClass: 'error_msg',
              })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },
  mounted() {
    // carsListSummary.api().then((res) => {
    //   if (res) {
    //     this.cars = res
    //     this.loading = false
    //   }
    // })
    // licenseChars.api().then((res) => {
    //   this.alphaList = res
    // })
  },
  computed: {
    maxDate() {
      let todayDate = new Date()
        .toLocaleDateString('en-us')
        .replaceAll('/', '-')
        .split('-')
      todayDate = `${todayDate[2]}-${todayDate[0]}-${todayDate[1]}`
      return this.gregorianToJalali(todayDate, 'fa')
    },
  },
}
</script>
